import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <rect width="14" height="14" x="1" y="1" stroke="#202020" strokeOpacity="0.5" strokeWidth="2" rx="1"></rect>
    </svg>
  )
}

export default Icon
